/*
 * @Author: lijing
 * @Date: 2022-08-25 10:40:08
 * @Last Modified by: lijing
 * @Last Modified time: 2022-08-26 17:20:43
 */
import React, { FC } from "react";
import { CourseList } from "./components/CourseList";

const CourseManage: FC = () => {
  return (
    <div className="coursemanage">
      <CourseList />
    </div>
  );
};

export default CourseManage;
